<div class="w-full flex flex-row justify-end -mb-10 mr-3">
  <button mat-mini-fab (click)="close()" color="warn">
    <mat-icon>close</mat-icon>
  </button>
</div> 

<img [src]="data" class="w-full h-full rounded-3xl" />
